var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2H17V4H19H21V6V8V10V20V22H19H5H3V20V10V8V6V4H5H7V2H9V4H15V2ZM9 6H7H5V8H19V6H17H15H9ZM5 10V20H19V10H5ZM7 12H9V14H7V12ZM13 12H11V14H13V12ZM15 12H17V14H15V12ZM9 16H7V18H9V16ZM11 16H13V18H11V16ZM17 16H15V18H17V16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarM);
export default __webpack_public_path__ + "static/media/calendar-m.cff91e69e4c71576639ffa2fae1ef01b.svg";
export { ForwardRef as ReactComponent };